module.exports = __webpack_public_path__ + "img/1_Cervical-esophagus.3b627387.png";